import React, { Component } from 'react'
import { Typeahead } from 'react-bootstrap-typeahead';
import { JobDetailById, JobSearchByTitle } from '../../action/jobs';
import { onChange, setOptions } from '../../utils';
import Swal from 'sweetalert2';
import Parser from 'html-react-parser';
import moment from 'moment';

export default class JobsModalList extends Component {

    constructor(props) {
        super(props)
        this.state = {
            JOB_TITLE:
            {
                name: 'JOB_TITLE',
                value: [],
                options: []
            },
            data: undefined,
        }
    }

    onCancel = () => {
        this.props.onCancel()
    }
    onSave = (data) => {
        this.props.onApply(data)
        this.props.onCancel()

    }
    jobSearch = (e) => {
        onChange(this, this.state.JOB_TITLE.name, e)

        if (e[0]?.JOB_ID) {
            JobDetailById(e[0].JOB_ID).then((res) => {
                if (res.status) {
                    this.setState({ data: res.result })
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        text: res.error,
                        timer: 5000,
                        showCancelButton: false,
                        showConfirmButton: false
                    })
                }
            }).catch(error => {
                Swal.fire({
                    icon: 'error',
                    text: error,
                    timer: 5000,
                    showCancelButton: false,
                    showConfirmButton: false
                })
            })
        }

    }

    onKeywordPress = (value) => {
        JobSearchByTitle(value).then(res => {
            if (res.status) {
                setOptions(this, this.state.JOB_TITLE.name, res.result.list)
            }
            else {
                alert(res.error)
            }
        })
    }

    render() {

        const { JOB_TITLE, data } = this.state
        const skill = data && data.KEYWORDS && data.KEYWORDS.map((d, i) => {
            return d.SKILL
        })

        return (
            <React.Fragment>
                <div className="">
                    <div className="input-box">
                        <label className="label-text">Select Jobs <span className='text-danger font-size-16'>*</span>
                        </label>
                        <div className="form-group">
                            <Typeahead
                                id="ta-jobs-ids"
                                allowNew={false}
                                labelKey={(option) => `${option.JOB_TITLE}`}
                                selected={JOB_TITLE.value}
                                multiple={false}
                                options={JOB_TITLE.options}
                                onChange={(e) => { this.jobSearch(e) }}
                                onInputChange={(e) => { this.onKeywordPress(e) }}
                                placeholder="Select Job"
                            />
                        </div>
                    </div>
                </div>

                {data &&
                    < table className="table table-striped mb-0">
                        <tbody>
                            <tr>
                                <td>Job Title</td>
                                <td>{data.JOB_TITLE}</td>
                            </tr>
                            <tr>
                                <td>Work from home during Covid / Permanent remote</td>
                                <td>{data.IS_WORK_FROM_HOME_DURING_COVID}</td>
                            </tr>
                            <tr>
                                <td>Key Skills</td>
                                <td>
                                    {skill.toString().replace(/,/g, ', ')}
                                </td>
                            </tr>
                            <tr>
                                <td>Work Experience (Years)</td>
                                <td>{`${data.WORK_EXP_MIN}-${data.WORK_EXP_MAX} year`}</td>
                            </tr>
                            <tr>
                                <td>Job Description</td>
                                <td>{data.JOB_DETAILS ? Parser(data.JOB_DETAILS) : "NA"}</td>
                            </tr>
                            <tr>
                                <td>Annual Salary Range</td>
                                <td>{`${data.CTC_MIN / 100000}-${data.CTC_MAX / 100000} LPA`}</td>
                            </tr>
                            <tr>
                                <td>Hide salary details from candidates</td>
                                <td>{data.IS_HIDE_SALARY_FROM_CANDIDATE}</td>
                            </tr>

                            <tr>
                                <td>Location</td>
                                <td>
                                    {data && data.CITY_ID && data.CITY_ID.map((d, i) => {
                                        return d.CITY
                                    })}
                                </td>
                            </tr>
                            <tr>
                                <td>Localities</td>
                                <td>
                                    {data && data.JOB_LOCATIONS && data.JOB_LOCATIONS.map((d, i) => {
                                        return d.LOCALITY
                                    })}
                                </td>
                            </tr>
                            {/* <tr>
                                <td>Industry</td>
                                <td>{data.INDUSTRY_ID}</td>
                            </tr> */}
                            {/* <tr>
                            <td>Functional Area</td>
                            <td>{data.FUNCTIONAL_AREA_ID}</td>
                        </tr> */}
                            {/* <tr>
                            <td>Role</td>
                            <td>{data.ROLE_ID}</td>
                        </tr> */}
                            <tr>
                                <td>Reference Code</td>
                                <td>{data.REFERENCE_CODE == "null" ? "NA" : data.REFERENCE_CODE}</td>
                            </tr>
                            <tr>
                                <td>Number Of Vacancies </td>
                                <td>{data.NO_OF_VACANCIES}</td>
                            </tr>
                            <tr>
                                <td>Qualification Type</td>
                                <td>
                                    {data && data.QUALIFICATION_ID && data.QUALIFICATION_ID.map((d, i) => {
                                        return d.QUALIFICATION_NAME
                                    })}
                                </td>
                            </tr>
                            <tr>
                                <td>Educational Qualification</td>
                                <td>
                                    {data && data.EDUCATION_QUALIFICATION_ID && data.EDUCATION_QUALIFICATION_ID.map((d, i) => {
                                        return d.COURSE_STREAM
                                    })}
                                </td>
                            </tr>
                            <tr>
                                <td>Course Specialization</td>
                                <td>
                                    {data && data.COURSE_SPECIALIZATION && data.COURSE_SPECIALIZATION.map((d, i) => {
                                        return d.SPECIALIZATION
                                    })}
                                </td>
                            </tr>
                            <tr>
                                <td>Include walk-in distance</td>
                                <td>{data.IS_INCLUDE_WALK_IN}</td>
                            </tr>
                            <tr>
                                <td>Walk-In Start Date</td>
                                <td>{moment(data.WALK_IN_START_DATE).format('DD-MMM-YYYY')}</td>
                            </tr>
                            <tr>
                                <td>Walk-In Start Timing</td>
                                <td>{data.WALK_IN_START_TIME == "null" ? "NA" : data.WALK_IN_START_TIME}</td>
                            </tr>
                            <tr>
                                <td>Walk-In End Timing</td>
                                <td>{data.WALK_IN_END_TIME == "null" ? 'NA' : data.WALK_IN_END_TIME}</td>
                            </tr>
                            <tr>
                                <td>Duration (Days)</td>
                                <td>{data.DURATION == "null" ? "NA" : data.DURATION}</td>
                            </tr>
                            <tr>
                                <td>Contact Person</td>
                                <td>{data.CONTACT_PERSON == "null" ? "NA" : data.CONTACT_PERSON}</td>
                            </tr>
                            <tr>
                                <td>Contact Number</td>
                                <td>{data.MOBILE_NUMBER == "null" ? "NA" : data.MOBILE_NUMBER}</td>
                            </tr>
                            <tr>
                                <td>Venue</td>
                                <td>{data.VENUE}</td>
                            </tr>
                            <tr>
                                <td>Google Map URL</td>
                                <td>Google Map URL</td>
                            </tr>
                            {/* <tr>
                                <td>Question</td>
                                <td>
                                    {data && data.QUESTION_ID && data.QUESTION_ID.map((d, i) => {
                                        return d.QUESTION
                                    })}
                                </td>
                            </tr> */}
                            <tr>
                                <td>Company Name</td>
                                <td>{data.COMPANY_NAME == "null" ? "NA" : data.COMPANY_NAME}</td>
                            </tr><tr>
                                <td>Client Name </td>
                                <td>{data.CLIENT_NAME == "null" ? "NA" : data.CLIENT_NAME}</td>
                            </tr>
                            <tr>
                                <td>Client Details Section</td>
                                <td>{data.CLIENT_DETAILS == "null" ? "NA" : data.CLIENT_DETAILS}</td>
                            </tr>
                            <tr>
                                <td>Client Company Address</td>
                                <td>{data.ADDRESS == "null" ? "NA" : data.ADDRESS}</td>
                            </tr>
                            {/* <tr>
                                <td>Upload Job Position Details</td>
                                <td>NA</td>
                            </tr> */}
                        </tbody>
                    </table>}

                {data && <div className='row'>
                    <div class="col-12 text-right pb-3 pt-3">
                        <button type='button' className='rg-btn theme-btn mr-2 py-1 px-2' style={{ border: 'none', outline: 'none', borderRadius: "4px" }} onClick={this.onCancel}>CANCEL</button>

                        <button type='button' className='rg-btn rg-active theme-btn py-1 px-3' style={{ border: 'none', outline: 'none', borderRadius: "4px" }} onClick={(e) => this.onSave(data.JOB_ID)} >Apply</button>
                    </div>
                </div>}
            </React.Fragment >
        )
    }

}